<script>
	export let src;
	export let userName;
	export let size;
	export let fontSize;
	export let isHost = false;
	let lineHeight;
	let userCharacter = '';
	let brokenlink = false;
	let containerHeight, textContainerWidth;
	let backgroundColors = [
		'linear-gradient(138.65deg, #2623D7 0%, #10B6DB 94.38%)',
		'linear-gradient(138.43deg, #FFD600 0%, #F10057 100.36%)',
		'linear-gradient(140.65deg, #FF0C0C 8.11%, #0019FF 100%)'
	];
	const color = Math.floor(Math.random() * backgroundColors.length);

	$: if (userName && typeof userName[0] === 'string') {
		userCharacter = userName[0].toUpperCase();
	} else {
		userCharacter = '';
	}

	$: if (fontSize) {
		lineHeight = parseInt(fontSize) * 1.5;
	}

	$: if (size) {
		containerHeight = parseInt(size) + 10;
		textContainerWidth = parseInt(size) - 10;
	}

	let handleError = () => {
		brokenlink = true;
	};
</script>

<div
	class="profile-avatar-container"
	style="--size: {size}px; --height: {containerHeight}px; --txtwidth: {textContainerWidth}px"
>
	{#if src && !brokenlink}
		<div class="profile-avatar-imgWrapper">
			<img class="profile-avatar-profilePicture" {src} on:error={handleError} alt="profile" />
			<div class="profile-avatar-ring" />
		</div>
	{:else}
		<div
			class="profile-avatar-fakeProfilePicture"
			style="--fontSize: {fontSize}px; --lineHeight: {lineHeight}px; --bg-color: {backgroundColors[
				color
			]}"
		>
			{userCharacter}
		</div>
	{/if}
	<div class="profile-avatar-textContainer">
		<span class="name">{userName}</span>
	</div>
	{#if isHost}
		<svg
			class="star"
			width="17"
			height="18"
			viewBox="0 0 17 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="8.5" cy="9" r="8.5" fill="#E94949" />
			<g clip-path="url(#clip0_597_14701)">
				<path
					d="M13.6378 8.60823C13.7571 8.51932 13.8457 8.39529 13.891 8.25353C13.9363 8.11177 13.9361 7.95939 13.8904 7.81775C13.8447 7.67611 13.7558 7.55232 13.6363 7.46374C13.5167 7.37515 13.3724 7.32621 13.2236 7.32378L10.3336 7.21461C10.3194 7.21362 10.3057 7.20856 10.2943 7.20001C10.2829 7.19146 10.2743 7.17981 10.2693 7.16644L9.27069 4.46911C9.22051 4.33188 9.12938 4.21338 9.00963 4.12966C8.88987 4.04594 8.74729 4.00104 8.60117 4.00104C8.45506 4.00104 8.31247 4.04594 8.19272 4.12966C8.07296 4.21338 7.98183 4.33188 7.93165 4.46911L6.93621 7.17607C6.93129 7.18944 6.92261 7.2011 6.91121 7.20964C6.89982 7.21819 6.8862 7.22326 6.87199 7.22424L3.98199 7.33342C3.83319 7.33585 3.68888 7.38479 3.56929 7.47337C3.44971 7.56196 3.36085 7.68575 3.31517 7.82739C3.26949 7.96902 3.26929 8.12141 3.31458 8.26316C3.35988 8.40492 3.44841 8.52895 3.56775 8.61786L5.8348 10.4C5.84614 10.409 5.85462 10.421 5.85919 10.4347C5.86376 10.4484 5.86421 10.4631 5.86049 10.4771L5.08019 13.2419C5.03975 13.3826 5.04367 13.5325 5.09141 13.671C5.13914 13.8094 5.22838 13.9299 5.34698 14.0158C5.46558 14.1018 5.60779 14.1491 5.75425 14.1514C5.90071 14.1537 6.04432 14.1108 6.16554 14.0286L8.56103 12.423C8.57283 12.4149 8.58683 12.4105 8.60117 12.4105C8.61551 12.4105 8.62951 12.4149 8.64131 12.423L11.0368 14.0286C11.1564 14.1136 11.2995 14.1593 11.4462 14.1593C11.593 14.1593 11.7361 14.1136 11.8556 14.0286C11.9743 13.9434 12.0636 13.8236 12.1113 13.6856C12.159 13.5476 12.1628 13.3982 12.1222 13.2579L11.3354 10.4835C11.3313 10.4696 11.3315 10.4547 11.3361 10.4409C11.3407 10.4271 11.3494 10.4151 11.3611 10.4064L13.6378 8.60823Z"
					fill="#FFBB38"
				/>
			</g>
			<defs>
				<clipPath id="clip0_597_14701">
					<rect width="11.56" height="11.56" fill="white" transform="translate(2.71997 3.21997)" />
				</clipPath>
			</defs>
		</svg>
	{/if}
</div>

<style>
	.profile-avatar-container {
		width: var(--size);
		height: var(--height);
		display: flex;
		flex-direction: column;
		margin: 0;
		padding: 0;
		position: relative;
	}
	.star {
		position: absolute;
		top: 0;
		right: 0;
	}
	.profile-avatar-textContainer {
		width: var(--txtwidth);
		height: 20px;
		margin: -10px 5px 0 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: var(--base-l-60);
		border-radius: 6px;
		z-index: 3;
	}
	.name {
		font-size: 10px;
		line-height: 14px;
		color: var(--base-d-60);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		margin: 2px 5px;
		font-family: 'Work Sans';
		font-weight: 700;
	}
	.profile-avatar-imgWrapper {
		width: var(--size);
		height: var(--size);
		position: relative;
	}
	.profile-avatar-ring {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		border: 5px solid rgba(255, 255, 255, 0.38);
		border-radius: 50%;
		position: absolute;
	}
	.profile-avatar-profilePicture {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		object-fit: cover;
		position: absolute;
	}
	.profile-avatar-fakeProfilePicture {
		width: var(--size);
		height: var(--size);
		font-family: Pally;
		font-style: normal;
		font-weight: 500;
		font-size: var(--fontSize);
		line-height: var(--lineHeight);
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		color: #ffffff;
		border: 5px solid rgba(255, 255, 255, 0.38) inset;
		border-radius: 50%;
		background: var(--bg-color);
		object-fit: cover;
	}
</style>
